import { render, staticRenderFns } from "./MiraDrying.vue?vue&type=template&id=3060b3e7&scoped=true&"
import script from "./MiraDrying.vue?vue&type=script&lang=ts&"
export * from "./MiraDrying.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDrying.vue?vue&type=style&index=0&id=3060b3e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060b3e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
